////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import _, { isEqual } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Modals from '../../../../components/Modals'
import Button from '../../../../components/Ui/Buttons'
import theme from '../../../../theme/theme'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDeleteScheduledActivateWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalCustom = styled.div`
	padding: 0;
`
/////////STYLED/////////
// [63]_k): MODIFY SCHEDULED ACTIVATION ITEM

const ModalDeleteScheduledActivate = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteScheduledActivate = () => {
		actionsArticleLifeManager.postDeleteScheduledActivate(props.deleteScheduledActivate.item.header.id)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.deleteScheduledActivate.close()
	}, [articleLifeManager?.isUpdate])

	const article = `<span style="color: ${theme.colors.primary}" > [${props?.deleteScheduledActivate?.item?.header?.itemRefLabel}] </span>`
	const date = `<span style="color: ${theme.colors.primary}" > ${moment(props?.deleteScheduledActivate?.currentDateScheduled?.dateToModify).format(
		'DD/MM/YYYY'
	)} </span>`
	let text = StringFormatter.ResponseMessageParser(
		_.replace(translations['modal__itemRef__timeline_action_activation_dateStart_edit_message'], '\\n', '<br>'),
		[article, date]
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDeleteScheduledActivateWrapper>
			<Modals
				showModal={props?.deleteScheduledActivate?.show}
				closeModalHandler={props?.deleteScheduledActivate?.close}
				level="error"
				icon={true}
				title={translations['modal__itemRef__timeline_action_activation_dateStart_edit_title']}
				width={555}
			>
				{translations && !isEqual(props?.deleteScheduledActivate?.item?.header, {}) && (
					<TextTopWrapper>
						<TextModalWrapper>{<TextModalCustom dangerouslySetInnerHTML={{ __html: text }} />}</TextModalWrapper>
					</TextTopWrapper>
				)}

				<ButtonWrapper>
					<Button
						actionHandler={props?.deleteScheduledActivate?.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleDeleteScheduledActivate()}
						text={translations['modal__itemRef__timeline_action_activation_dateStart_edit_buttons_validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalDeleteScheduledActivateWrapper>
	)
}

ModalDeleteScheduledActivate.propTypes = {}

ModalDeleteScheduledActivate.defaultPropTypes = {}

export default ModalDeleteScheduledActivate
